import { i18nLike } from "#web/services/i18nLike";
import { useAppBridge } from "@shopify/app-bridge-react";
import { BlockStack, Button, ButtonGroup, Card, Text } from "@shopify/polaris";
import { stackImage } from "#web/assets";

const en = {
  contactUs: "Get early access",
  copied: "Email address copied to clipboard",
  documentation: "Open documentation",
  subtitle: "Allow and disallow certain coupon codes to stack, smart bundling, and more.",
  title: "Want a smart discount stacking tool?",
};

export function StackAppPromotion() {
  const t = i18nLike(en);
  const shopify = useAppBridge();

  const handleContactUs = () => {
    void navigator.clipboard.writeText("support@keepcart.co");
    shopify.toast.show(t("copied"), {
      duration: 4000,
    });
  };

  return (
    <Card padding="0">
      <div
        style={{
          position: "relative",
          overflow: "hidden",
          borderRadius: 16,
          minHeight: 60,
          background: "#1a1a1a",
          padding: 0,
        }}
      >
        <img
          src={stackImage}
          alt="Stack background"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: 0,
            opacity: 0.7,
          }}
        />
        <div
          style={{
            position: "relative",
            zIndex: 1,
            color: "#fff",
            padding: "20px 32px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            minHeight: 60,
          }}
        >
          <BlockStack gap="100">
            <Text as="h3" variant="headingMd">
              {t("title")}
            </Text>
            <BlockStack gap="300">
              <Text as="p" variant="bodyMd">
                {t("subtitle")}
              </Text>
              <ButtonGroup>
                <Button onClick={handleContactUs} variant="secondary">
                  {t("contactUs")}
                </Button>
              </ButtonGroup>
            </BlockStack>
          </BlockStack>
        </div>
      </div>
    </Card>
  );
}
